import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: 'var(--primary-colors--primary-1)',
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: 'rgba(255, 255, 255, 0.7)',
  '&.Mui-selected': {
    color: '#fff',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
}));

export default function AgentTabs({agents, selectedIndex, onSelect}: {agents: string[], selectedIndex: number, onSelect: (index: number) => void}) {

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onSelect(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}
    display="flex"
  justifyContent="center"
  alignItems="center">
        <StyledTabs
          value={selectedIndex}
          onChange={handleChange}
          aria-label="styled tabs example"
        >
          {agents.map((agent) => <StyledTab key={agent} label={agent} />)}
        </StyledTabs>
    </Box>
  );
}